// UQ-ko-KR
module.exports = {
  "forTest": "test for UQ-ko-KR",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "공식 스타일링",
  "text_styling_book_stylehint": "스타일 힌트",
  "text_sort": "정렬 기준",
  "text_filter": "필터",
  "text_styling_book_search_results_number": "{total} 건",
  "text_active_filters": "선택한 필터",
  "text_styling_book_clear_all_filters": "모두 지우기",
  "text_styling_book_search_by_feature": "컬렉션에서 검색",
  "text_styling_book_search_by_category": "카테고리에서 검색",
  "text_styling_book_staff_customer_filter_all": "모두",
  "text_styling_book_search_by_coordinate": "키워드에서 검색",
  "text_styling_book_staff_customer_filter_title": "게시자",
  "text_styling_book_search_by_height": "키에서 검색",
  "text_styling_book_search_by_hashtag": "해시태그에서 검색",
  "text_styling_book_staff_customer_filter_customer_styling": "고객님",
  "text_styling_book_staff_customer_filter_staff_styling": "UNIQLO 스탭",
  "text_apply_search_filter": "적용하기",
  "text_styling_book_no_results": "결과 없음",
  "text_error_title": "서비스를 일시적으로 사용할 수 없습니다.",
  "text_503_error_description-1": "죄송합니다. 일시적으로 시스템 오류가 발생 하였습니다.",
  "text_503_error_description-2": "나중에 다시 방문하거나, 이전 페이지로 돌아가 주세요.",
  "text_503_error_instruction": "궁금한 사항이 있으시면, 아래 링크에서 확인해주시기 바랍니다.",
  "text_styling_book_go_to_top": "UNIQLO home",
  "text_contactus": "고객센터",
  "text_wishlist": "위시리스트",
  "text_membership_info": "회원정보",
  "text_wearing_items": "스타일링한 제품",
  "text_color": "컬러",
  "text_size": "사이즈",
  "text_stylehint_non_listed_items_message_01": "※ 위에 게재되지 않은 착용제품은 타사브랜드제품 또는 유니클로 과거제품입니다.",
  "text_styling_book_related_styling_title": "관련 스타일링",
  "text_style_styling_date_update": "업데이트",
  "text_styling_book_hashtag_title": "해시태그",
  "currency_format": "{price} 원",
  "text_404": "페이지를 찾을 수 없습니다.",
  "text_official_styling_top_page_link": "공식 스타일링 상위 페이지",
  "text_stylehint_top_page_link": "스타일 힌트 상위 페이지",
  "text_breadcrumbs_top": "UNIQLO",
  "text_a11y_close": "닫기",
  "text_log_in": "로그인",
  "text_app_update_dialog_cancel": "취소",
  "text_menu": "Menu",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. All rights reserved.",
  "text_stylehintapp": "스타일 힌트 앱",
  "text_styling_book_official_styling_page_title": "공식 스타일링",
  "text_styling_book_stylehint_page_title": "스타일 힌트",
  "text_styling_book_sort_latest": "신상품순",
  "text_styling_book_sort_popular": "판매순",
  "text_styling_book_search_by_color": "컬러 검색",
  "text_filter_clear_all_category": "모든 카테고리 지우기",
  "text_styling_book_filter_height_over": "이상",
  "text_styling_book_filter_height_under": "이하",
  "text_show_all": "모두 보기",
  "text_error_description": "시스템 오류가 발생했습니다. 다시 시도하거나, 나중에 다시 방문해 주세요.",
  "text_system_error": "시스템 오류",
  "text_ok": "확인",
  "text_login_required": "로그인 필요",
  "text_login_request": "로그인 페이지로 이동하세요.",
  "text_error_failed_sort_product": "선택하신 기준에 맞는 제품이 존재하지 않습니다. 재검색 해주시길 바랍니다.",
  "text_error_failed_update_filter_criteria": "필터 기준을 업데이트하지 못했습니다. 다시 시도해 주세요.",
  "text_meta_title_postfix": "| UNIQLO",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "WOMEN",
  "text_styling_book_meta_men": "MEN",
  "text_styling_book_meta_kids": "KIDS",
  "text_styling_book_meta_baby": "BABY",
  "text_styling_book_official_gender_meta_description": "{brand} 공식 온라인 스토어의 스타일링 북입니다. {gender}의 패션 제품을 스타일링하기 위해 최신 트렌드를 알아보세요. 모델들이 착용한 제품도 온라인 매장에서 만나보세요.",
  "text_styling_book_official_gender_meta_title": "{gender} 착용 제품 리스트{uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "{gender}의 「{filterOptions}」 착용 리스트 {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "{brand}의 제품으로 {gender} 「{filterOptions}」 스타일링 팁 및 트렌드에 맞는 제품으로 스타일링하는 방법을 만나보세요.",
  "text_styling_book_official_detail_meta_title": "「{officialProducts}」을(를) 착용하였습니다.{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "「{officialProducts}」의 이번 시즌 스타일 및 전체 스타일링을 {brand}.com에서 확인해보세요!",
  "text_styling_book_stylehint_gender_meta_title": "{gender} 패션 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "{brand} 공식 스타일 힌트. 매장 스탭, 고객의 {gender} 스타일링「{count}」건을 만나보세요.",
  "text_styling_book_stylehint_filter_meta_title": "{gender}의 「{filterOptions}」스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "{userName}({storeName})의 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "{userName}의 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "{userName}({height})의 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "「{stylehintProducts}」의 착용 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "{brand}({storeName})의 스탭 {staffName}({height} 의 스타일링를 만나보세요. 최신 트렌드 제품을 활용한 스타일링 방법도 확인해보세요.",
  "text_styling_book_stylehint_ins_user_meta_description": "Instagram 유저인 {userName}」의 {brand} 제품으로 믹스매치한 스타일링 팁 을 만나보세요. 다른 유저들의 스타일링도 만나볼 수 있으며 최신 트렌드 제품의 스타일링 방법도 확인해보세요.",
  "text_styling_book_stylehint_customer_user_meta_description": "{brand} 제품을 착용한 {userName} ({height}) 스타일링를 만나보세요. 온라인 스토어에서 모델이 착용한 제품도 확인해보세요.",
  "text_styling_book_stylehint_detail_meta_description": "{brand}의「{stylehintProducts}」을(를) 활용한 스타일링를 소개합니다. 매장 스탭와 고객의 스타일링도 놓치지 마세요.",
  "text_styling_book_stylehint_filter_meta_description": "{brand} 제품을 활용한 {gender} {filterOptions} 스타일링 팁 {searchCount}건을 확인해보세요. 온라인 스토어에서 신상품과 인기 상품도 놓치지 마세요.",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand}스타일링 북 스타일링 팁 스타일 ID: <{styleid}>",
  "text_styling_book_official_styling_id_alt_tag": "{brand}스타일링 북 스타일링 팁 스타일 ID: <{styleid}>",
  "text_styling_book_official_detail_id_alt_tag": "「{officialProducts}」의 스타일링 팁을 확인해보세요",
  "text_styling_book_stylehint_detail_id_alt_tag": "「{stylehintProducts}」의 스타일링 팁을 확인해보세요",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "{gender} 「{hashtag}」의 스타일링 팁",
  "text_styling_book_stylehint_feature_alt_tag": "{gender} 「{feature}」의 스타일링 팁",
  "text_style_model_height": "cm",
  "text_503_error_description": "죄송합니다. 일시적 시스템 오류가 발생 하였습니다. 나중에 다시 방문하거나, 이전 페이지로 돌아가세요.",
  "text_styling_book_meta_official_styling": "스타일링 아이디어",
  "text_styling_book_meta_stylehint": "스타일링 아이디어",
  "text_limited_offer_until_date": "{startDate}에서 {date}까지 {flagName}",
  "text_online_store_exclusive_limited_offer_until_date": "{startDate}에서 {date}까지 {flagName}",
  "text_app_membership_exclusive_limited_offer_until": "{startDate}에서 {date}까지 {flagName}",
  "text_csoon_early": "{month} 초 판매예정",
  "text_csoon_mid": "{month} 중순 판매예정",
  "text_csoon_late": "{month} 말 판매예정",
  "text_men": "MEN",
  "text_women": "WOMEN",
  "text_kids": "KIDS",
  "text_baby": "BABY",
  "text_unisex": "GENDERLESS",
  "text_app_membership_exclusive_limited_offer": "APP회원 한정",
  "text_styling_book_gender_menu_kids_and_baby": "KIDS / BABY",
  "text_styling_book_meta_kids_and_baby": "",
  "text_a11y_favorites_add": "위시리스트에 추가",
  "text_close": "닫기",
  "text_error_wishlist_max": "제품 개수가 최대 한도인 999개에 초과했습니다. 이 제품을 추가하려면 위시리스트를 편집하세요.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "이미지 없음",
  "text_wearing_size_code01": "착용 사이즈: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "영어",
  "text_locale_fr": "",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "이 제품은 품절 되었습니다.",
  "text_product_display_markdown": "{startDate}부터 {flagName}",
  "text_color_white": "White",
  "text_color_gray": "Gray",
  "text_color_black": "Black",
  "text_color_pink": "Pink",
  "text_color_red": "Red",
  "text_color_orange": "Orange",
  "text_color_beige": "Beige",
  "text_color_brown": "Brown",
  "text_color_yellow": "Yellow",
  "text_color_green": "Green",
  "text_color_blue": "Blue",
  "text_color_purple": "Purple",
  "text_promotion": "프로모션",
  "text_styling_promotion_hashtag": "프로모션",
  "text_coming_soon": "출시 예정",
  "text_markdown": "판매",
  "text_multibuy_markdown": "세트할인, 가격인하",
  "text_multibuy_limited_offer_until_date": "세트할인, {date}까지 기간 한정",
  "text_app_membership_exclusive_multi_buy_until": "{startDate}에서{date}까지 앱회원한정 세트할인",
  "text_app_membership_exclusive_multi_buy": "앱회원한정 세트할인",
  "text_app_membership_exclusive_limitedoffers_until": "{startDate}에서{date}까지 앱회원한정 기간한정가격",
  "text_item_preorder_color_size_only": "선주문(일부 색상 / 사이즈)",
  "text_item_resale_color_size_only": "재입고(일부 색상 / 사이즈)"
}; // generated at Thu May 30 2024 09:40:42 GMT+0800 (Hong Kong Standard Time)